import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreAlarmLogsReportList',
  props: {
    smartGroupId: {
      type: Number,
      required: false,
      default: null
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showCreateDialog: false,
      selectedAccountIds: [],
      accountFilterReady: false,
      editingItem: null,
      itemIdToBeDeleted: null,
      accountFilterIsReady: false,
      cacheBuster: 0
    };
  },
  computed: {
    ...mapState('app', ['color']),
    tableHeaders() {
      return [{
        text: this.$i18n_t('Common.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('AlarmLogs.reports.wizard.name'),
        value: 'title',
        width: '350px',
        sortable: true
      }, {
        text: this.$i18n_t('Common.drawer.monitoringViews'),
        value: 'smartGroupId',
        width: '150px',
        sortable: true
      },
      // {
      //   text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newErrors'),
      //   value: 'errorCount',
      //   sortable: false,
      // },
      // {
      //   text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newWarnings'),
      //   value: 'warningCount',
      //   sortable: false,
      // },
      {
        text: this.$i18n_t('AlarmLogs.table.headers.account'),
        value: 'tenantId',
        width: '150px',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastTriggered'),
        value: 'lastTrigger',
        sortable: true
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
        isButtons: true,
        align: 'center',
        sortable: false,
        buttons: [{
          icon: 'fal fa-edit',
          color: this.color,
          onClick: item => {
            this.editItem(item);
          }
        }, {
          icon: 'fal fa-trash-alt',
          color: this.color,
          onClick: item => {
            this.onDeleteClick(item);
          }
        }]
      }].filter(item => {
        return !item.hide || !this.$vuetify.breakpoint[item.hide];
      });
    }
  },
  methods: {
    localizeDate,
    accountSelectionChanged(accounts) {
      this.selectedAccountIds = accounts.map(account => account.id);
    },
    async fetchList(options) {
      const {
        page,
        perPage,
        sortBy,
        sortDirection,
        selectedAccountIds
      } = options;
      const sortOrder = {
        variable: sortBy || 'id',
        direction: sortDirection
      };
      let searchItems = [];
      if (selectedAccountIds.length > 0) {
        searchItems.push({
          variable: 'tenantIds',
          search: selectedAccountIds
        });
      }
      if (this.smartGroupId != null) {
        searchItems.push({
          variable: 'smartGroupId',
          search: this.smartGroupId
        });
      }
      const response = await ApiService.fetchAlarmLogReports(this, page, perPage, searchItems, sortOrder, true);
      return {
        items: response.reports.map(report => {
          return {
            ...report,
            title: report.meta.title,
            smartGroupId: report.smartGroup.title,
            tenantId: report.tenant.name,
            errorCount: report.counts.newErrors !== null ? report.counts.newErrors : 'N/A',
            warningCount: report.counts.newWarnings !== null ? report.counts.newWarnings : 'N/A',
            lastTrigger: report.lastTrigger ? this.localizeDate(report.lastTrigger) : '-'
          };
        }),
        total: response.pagination.total
      };
    },
    editItem(item) {
      this.editingItem = cloneDeep(item);
      this.editingItem.tenantId = this.editingItem.tenant.id;
      this.editingItem.smartGroupId = this.editingItem.smartGroup.id;
      this.showCreateDialog = true;
    },
    reloadList() {
      this.closeDialog();
      this.cacheBuster++;
    },
    closeDialog() {
      this.showCreateDialog = false;
      this.editingItem = null;
    },
    onDeleteClick(item) {
      this.itemIdToBeDeleted = item.id;
    },
    async onDeleteItemConfirm() {
      const itemId = this.itemIdToBeDeleted;
      try {
        await ApiService.deleteAlarmReport(this, itemId);
        this.$snack(this.$i18n_t('AlarmLogs.snacks.reportDeleteSuccess'), 'success');
        this.cacheBuster += 1;
      } catch (error) {
        console.error(error);
        this.$snack(this.$i18n_t('AlarmLogs.snacks.reportDeleteError'), 'error');
      } finally {
        this.itemIdToBeDeleted = null;
      }
    }
  }
};